export default __webpack_public_path__ + "static/media/billing_management_web.739e811a.PNG";